module.exports = __webpack_public_path__ + "static/youtube-avatar-03a5a3d2d6e16a959bdcfccec317dcff.jpg";